import { css } from 'styled-components';

import {
  colorGuidance400,
  colorGuidance500,
  colorGuidance700,
  colorGuidance800,
  colorNeutral,
  colorPlaceholder,
} from './colors';

export const focus = css`
  &:focus-visible {
    outline-offset: 3px;
    border-radius: 3px;
    outline: solid 3px ${colorGuidance500};
  }
`;

export const focusDark = css`
  &:focus-visible {
    outline-offset: 3px;
    border-radius: 3px;
    outline: solid 3px ${colorGuidance400};
  }
`;

export const placeholder = css`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${colorPlaceholder};
  overflow: hidden;

  &::before {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background: linear-gradient(to right, rgb(255 255 255 / 0%), ${colorNeutral}, rgb(255 255 255 / 0%));
    animation: load 1.4s linear infinite;
  }

  @keyframes load {
    from {
      left: -100%;
    }

    to {
      left: 100%;
    }
  }
`;

export const link = css`
  color: ${colorGuidance700};

  &:hover {
    color: ${colorGuidance800};
  }

  ${focus}
`;
